import { useEffect, useState } from "react";

const initialState = {
    tipo: "PRESTAMO",
    entidad: "",
    montoInicial: "",
    tasaInteres: "",
    saldoPendiente: "",
    fechaInicio: "",
    fechaFin: "",
    estado: "ACTIVA",
};

export default function DeudaForm({ initialData, onClose, onSave }) {
    const [form, setForm] = useState(initialState);

    useEffect(() => {
        if (initialData) {
            setForm({
                ...initialState,
                ...initialData,
                montoInicial: initialData.montoInicial ?? "",
                tasaInteres: initialData.tasaInteres ?? "",
                saldoPendiente: initialData.saldoPendiente ?? "",
                fechaInicio: initialData.fechaInicio ?? "",
                fechaFin: initialData.fechaFin ?? "",
            });
        } else {
            setForm(initialState);
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        await onSave({
            ...form,
            montoInicial: Number(form.montoInicial || 0),
            tasaInteres: form.tasaInteres === "" ? null : Number(form.tasaInteres),
            saldoPendiente: Number(form.saldoPendiente || 0),
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3>{initialData ? "Editar deuda" : "Nueva deuda"}</h3>
                    <button type="button" onClick={onClose}>X</button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Tipo</label>
                        <select name="tipo" value={form.tipo} onChange={handleChange}>
                            <option value="PRESTAMO">Préstamo</option>
                            <option value="TARJETA">Tarjeta</option>
                            <option value="CREDITO">Crédito</option>
                        </select>
                    </div>

                    <div>
                        <label>Entidad</label>
                        <input
                            name="entidad"
                            placeholder="Ej. BCP"
                            value={form.entidad}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Monto inicial</label>
                        <input
                            name="montoInicial"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.montoInicial}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Tasa de interés</label>
                        <input
                            name="tasaInteres"
                            type="number"
                            step="0.01"
                            placeholder="Ej. 15.50"
                            value={form.tasaInteres}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Saldo pendiente</label>
                        <input
                            name="saldoPendiente"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.saldoPendiente}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Fecha fin</label>
                        <input
                            name="fechaFin"
                            type="date"
                            value={form.fechaFin || ""}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Fecha inicio</label>
                        <input
                            name="fechaInicio"
                            type="date"
                            value={form.fechaInicio || ""}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button type="button" onClick={onClose}>Cancelar</button>
                        <button type="submit">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}